import * as d3 from 'd3';
import moment from 'moment';
import DayAxis from './DayAxis.js';
import Label from './Label.js';
import Row from './Row.js';
import Tooltip from './Tooltip.js';
import WeekAxis from './WeekAxis.js';
import MonthAxis from './MonthAxis.js';
import QuarterAxis from './QuarterAxis.js';
import RowMilestones from './RowMilestoneBar.js';
import YearAxis from './YearAxis.js';

export default class Chart {
  constructor(element, data, options) {
    this.element = element;
    this.data = data;
    this.options = options;
    this.components = [];
  }

  set data(data) {
    this._data = {
      rows: data.rows.map((item, index) => {
        return {
          ...item,
          row: index,
          startDate: moment(item.startDate).startOf('day').toDate(),
          endDate: moment(item.endDate).endOf('day').toDate(),
        };
      }),
      lines: data.lines,
    };
  }

  get data() {
    return this._data;
  }

  update() {
    this.components.forEach((component) => component.update());
  }

  rebuild() {
    this.chart.remove();
    this.build();
  }

  buildComponents(components) {
    components.forEach((component, index) => {
      this.components[index] = new component({
        chart: this.chart,
        data: this.data,
        options: this.options,
      });
      this.components[index].build();
    });
  }

  build() {
    d3.select(this.element).selectAll('svg').remove(); // clearing previous

    const { width } = this.options;

    const calcHeight = () => this.data.rows.length * 32 + 12;
    const minHeight = this.options.minHeight || 300;
    const height = Math.max(calcHeight(), minHeight);
    this.options.height = height;

    this.chart = d3
      .select(this.element)
      .append('svg')
      .attr('class', 'chart')
      .attr('width', width)
      .attr('height', height);
    const componentsToInclude = [];

    if (this.options.scaleType === 'week') {
      componentsToInclude.push(DayAxis);
      componentsToInclude.push(WeekAxis);
    }

    if (this.options.scaleType === 'month') {
      componentsToInclude.push(MonthAxis);
      componentsToInclude.push(WeekAxis);
    }

    if (this.options.scaleType === 'quarter') {
      componentsToInclude.push(MonthAxis);
      componentsToInclude.push(QuarterAxis);
    }

    if (this.options.scaleType === 'year') {
      componentsToInclude.push(QuarterAxis);
      componentsToInclude.push(YearAxis);
    }

    componentsToInclude.push(Row);
    componentsToInclude.push(RowMilestones);

    componentsToInclude.push(Tooltip);
    componentsToInclude.push(Label);

    this.buildComponents(componentsToInclude);
  }
}
